import i18n from '../../../base-dictionary';
import { PerformanceTab } from './initiative-performance.type';

const tabs = [
  {
    id: PerformanceTab.Throughput,
    label: i18n.t('strategy.initiative_performance.throughput'),
    icon: 'calendar_month',
  },
  { id: PerformanceTab.Focus, label: i18n.t('strategy.initiative_performance.focus'), icon: 'center_focus_strong' },
  {
    id: PerformanceTab.FlowByPhase,
    label: i18n.t('strategy.initiative_performance.flow_by_phase'),
    icon: 'swap_calls',
  },
  { id: PerformanceTab.Targets, label: i18n.t('strategy.initiative_performance.targets'), icon: 'ads_click' },
  { id: PerformanceTab.Cost, label: i18n.t('strategy.initiative_performance.cost'), icon: 'payments' },
  {
    id: PerformanceTab.RelatedTasks,
    label: i18n.t('strategy.initiative_performance.related_work_units'),
    icon: 'task_alt',
  },
];

export { tabs };
